import React from 'react';
import moment from 'moment';
import Typography from '@mui/material/Typography';
import Card from 'components/Card';
import { number_format } from 'functions';

function CellFatura(props) {
  const { fatura } = props;

  return (
    <Card
      style={{ marginBottom: '10px', paddingTop: '10px', paddingBottom: '10px' }}
      bordered
      borderhexcolor={props.status_color}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'space-between',
          gap: '140px',
          width: '100%',
        }}
      >
        <div style={{ flex: '1 1 auto', minWidth: 0, maxWidth: '52%' }}>
          <Typography variant="body2" gutterBottom style={{ marginBottom: '16px' }}>
            <strong>{fatura.client.social_name}</strong> - {fatura.client.cgccpf}
          </Typography>

          <Typography variant="caption" component="p" gutterBottom style={{ marginBottom: '12px' }}>
            <strong>Fatura: </strong> {fatura.invoice_number || ''}
          </Typography>

          <Typography
            variant="caption"
            component="p"
            gutterBottom
            style={{ marginBottom: 0, lineHeight: 1.9 }}
          >
            <strong>CTE/NFS:</strong> {fatura.cte_number || fatura.nfs || ''}
            {fatura.emitteds.length > 0 &&
              `, ${fatura.emitteds
                .map((el) => {
                  return el.cte_number;
                })
                .join(', ')}`}
          </Typography>
        </div>

        <div
          style={{
            flex: '0 0 320px',
            minWidth: '320px',
            paddingLeft: '40px',
          }}
        >
          <Typography variant="caption" component="p" gutterBottom style={{ marginBottom: '12px' }}>
            <strong>Status: </strong>
            {fatura.status}
          </Typography>

          <Typography variant="body2" gutterBottom style={{ marginBottom: '12px' }}>
            <strong>Valor: </strong>
            R$ {number_format(fatura.invoice_amount, 2, ',', '.')}
          </Typography>

          <Typography variant="body2" gutterBottom style={{ marginBottom: 0 }}>
            <strong>Vencimento: </strong>
            {fatura.due_date ? moment(fatura.due_date).format('DD/MM/YYYY') : ''}
          </Typography>
        </div>
      </div>
    </Card>
  );
}

export default CellFatura;
